import script from "./Restore.vue?vue&type=script&setup=true&lang=js"
export * from "./Restore.vue?vue&type=script&setup=true&lang=js"

import "./Restore.vue?vue&type=style&index=0&id=74cb67a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74cb67a0"]])

export default __exports__